__turbopack_context__.v({
  "changeLoginMethod__form": "ChangeLoginMethodCard-module__D1KdkG__changeLoginMethod__form",
  "changeLoginMethod__method": "ChangeLoginMethodCard-module__D1KdkG__changeLoginMethod__method",
  "changeLoginMethod__methodEditing": "ChangeLoginMethodCard-module__D1KdkG__changeLoginMethod__methodEditing",
  "changeLoginMethod__methodTile": "ChangeLoginMethodCard-module__D1KdkG__changeLoginMethod__methodTile",
});
